import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=676bfdac&scoped=true&"
import script from "./reservation.vue?vue&type=script&lang=ts&"
export * from "./reservation.vue?vue&type=script&lang=ts&"
import style0 from "./reservation.vue?vue&type=style&index=0&id=676bfdac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bfdac",
  null
  
)

export default component.exports